import Vue from 'vue'

const onlyNumbers = value => value.toString().replace(/[^0-9]/g, '')

Vue.filter('onlyNumbers', onlyNumbers)

export default onlyNumbers
